<template>
  <div class="w-full">
    <v-chart v-loading="chartLoading" :options="option" autoresize class="w-full h-200px"></v-chart>
  </div>
</template>

<script>
export default {
  name: 'defect-bar-chart',
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    option() {
      // 名称集合
      const groupNames = this.values.map((item) => {
        return item.speciality
      })
      // 已处理集合
      const handledStatistics = this.values.map((item) => {
        return item.handle_nb
      })
      // 未处理集合
      const unhandledStatistics = this.values.map((item) => {
        return item.unhandle_nb
      })
      return {
        title: {
          text: '',
          left: '14%',
          top: '40%',
          textStyle: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.8)',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: 40,
          right: 10,
          bottom: 30,
        },
        xAxis: [
          {
            type: 'category',
            data: groupNames,
            axisLabel: {
              color: '#fff',
            },
            axisLine: {
              lineStyle: {
                color: '#6f717a',
              },
            },
            axisTick: {
              lineStyle: {
                color: '#6f717a',
              },
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#fff',
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          }
        ],
        series: [
          {
            name: '已处理',
            type: 'bar',
            data: handledStatistics,
            label: {
              show: false,
            },
            itemStyle: {
              color: '#5087ec',
            },
          },
          {
            name: '未处理',
            type: 'bar',
            data: unhandledStatistics,
            label: {
              show: false,
            },
            itemStyle: {
              color: '#68bbc4',
            },
          },
        ],
      }
    },
  },
  data() {
    return {
      chartLoading: false,
      dataList: [
        {
          value: 0,
          name: '重大隐患',
        },
        {
          value: 0,
          name: '一般隐患',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
